import { render, staticRenderFns } from "./H1ParcelDeclarationDetailsTab.vue?vue&type=template&id=3eeab2a9&"
import script from "./H1ParcelDeclarationDetailsTab.vue?vue&type=script&lang=js&"
export * from "./H1ParcelDeclarationDetailsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports